import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const StyledMapWrapper = styled(Box)`
    height: 100vh;
`;
